import React, { FC, useState } from 'react';

import { AtsType, IntegrationType } from 'src/generated/mloop-graphql';

import {
  SmartRecruitersIntegration,
  useIntegrationAuthorizeUrl,
  useIntegrationDelete,
} from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

import { DisconectAtsDialog } from '../Dialogs/DisconnectAtsDialog';
import SmartRecruitersDialog from '../Dialogs/SmartRecruitersDialog';
import IntegrationCard from '../IntegrationCard';

import { ConnectAtsButton } from './ConnectAtsButton';

export interface Props {
  smartRecruiters?: SmartRecruitersIntegration;
  disabled?: boolean;
  onRemove?: () => void;
}

const SmartRecruitersCard: FC<Props> = ({ smartRecruiters, disabled = false, onRemove }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);
  const [openConnectDialog, setOpenConnectDialog] = useState<boolean>(false);

  const { data: smartRecruitersAuthData } = useIntegrationAuthorizeUrl({
    integration_type: IntegrationType.SmartRecruiters,
    redirect_uri: '',
    login_hint: '',
  });
  const deleteSmartRecruiters = useIntegrationDelete(IntegrationType.SmartRecruiters);

  const atsService = getAtsService(AtsType.SmartRecruiters);

  return (
    <>
      <IntegrationCard
        dataTestId="smartrecruiters-card-integration-card"
        logo={atsService.logoUrl}
        name="SmartRecruiters"
        onConnect={
          !smartRecruiters?.active && smartRecruitersAuthData
            ? () => window.open(smartRecruitersAuthData.url, '_blank')
            : undefined
        }
        onReconnect={smartRecruiters?.active ? () => setOpenConnectDialog(true) : undefined}
        onRemove={smartRecruiters?.active ? () => setOpenRemoveDialog(true) : undefined}
        disabled={disabled}
        disableManageSetup={disabled}
        connectButton={
          <ConnectAtsButton
            dataTestId="smartrecruiters-card-integration-card"
            handleConnect={() => setOpenConnectDialog(true)}
            disabled={disabled}
          />
        }
      />
      {openConnectDialog && (
        <SmartRecruitersDialog
          active={smartRecruiters?.active || false}
          apiKey={smartRecruiters?.api_key || undefined}
          onClose={() => setOpenConnectDialog(false)}
          onSave={() => window.open(smartRecruitersAuthData?.url, '_blank')}
          disabled={disabled}
        />
      )}

      {openRemoveDialog && (
        <DisconectAtsDialog
          integrationName={atsService.name}
          onClose={() => setOpenRemoveDialog(false)}
          onRemove={() => {
            setOpenRemoveDialog(false);
            deleteSmartRecruiters.mutate(undefined, {
              onSuccess: () => {
                onRemove?.();
              },
            });
          }}
        />
      )}
    </>
  );
};

export default SmartRecruitersCard;
